import { useTranslation } from 'react-i18next';
import { HoverCard, HoverCardContent, HoverCardTrigger } from './ui/hover-card';
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';

type PaymentNotAvailableHoverCardProps = {
  children: React.ReactNode;
  isAvailable: boolean;
};

const PaymentNotAvailableHoverCard = ({
  children,
  isAvailable,
}: PaymentNotAvailableHoverCardProps) => {
  const { t } = useTranslation();
  if (isAvailable) {
    return <>{children}</>;
  }

  return (
    <HoverCard>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent
        className='w-[--radix-hover-card-trigger-width]'
        align='start'
        side='top'
        sideOffset={5}
      >
        <span className='text-md flex items-center border-b pb-2 font-semibold text-yellow-400'>
          <ExclamationTriangleIcon className='mr-2 h-4 w-4' />
          {t('Payment Not Available')}
        </span>
        <p className='mt-2 text-sm text-muted-foreground'>
          {t(
            `We're sorry, but this payment option is not currently available. Please select a different payment option.`,
          )}
        </p>
      </HoverCardContent>
    </HoverCard>
  );
};

export default PaymentNotAvailableHoverCard;
